export const BUTTON_SIZE_TYPOGRAPHY = {
  large: {
    fontSize: '16px',
    lineHeight: '22px',
  },
  medium: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  small: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  extraSmall: {
    fontSize: '12px',
    lineHeight: '16px',
  },
} as const;
